<template>
    <!-- 유저 기본 정보   , 정지사유 , 해지 , 해지 사유 , 메일 이력  [쿠폰 사용 내역-> 이건 필요할때 넣도록 한다 ] -->
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-sheet :color="MailType_TabColor" dark class="userinfo-toolbar">
      <div class="userinfo-toolbar__row">
        <div v-if="is_van == false" class="userinfo-toolbar__title white--text">
          {{`아이디: ${targetUser}`}}
        </div>
        <div v-else class="userinfo-toolbar__title white--text">
          정지된 유저입니다. {{targetUser}} {{`(과금 합계 :  ${this.Purchase_Sum_String} 원)`}}
        </div>
        <div class="userinfo-toolbar__actions">
          <v-chip small dark color="rgba(255,255,255,0.2)" class="mr-2">
            추천인: {{!dialog_referee_list_items_loaded ? '-' : dialog_referee_list_items.length}}명
          </v-chip>
          <v-btn small outlined dark @click="Show_UserReferees">
            <v-icon left small>mdi-account-multiple</v-icon>전체보기
          </v-btn>
        </div>
      </div>
    </v-sheet>

    <v-tabs
        v-model="userInfoTab"
        grow
        show-arrows
        color="primary"
        slider-color="primary"
        background-color="grey lighten-4"
        class="user-info-tabs"
        icons-and-text
    >
        <v-tab class="user-info-tab">
            <span class="user-info-tab-text">아이디 기본정보</span>
            <v-icon class="ml-1" size="18">mdi-account-circle</v-icon>
        </v-tab>
        <v-tab class="user-info-tab">
            <span class="user-info-tab-text">정지관리</span>
            <v-icon class="ml-1" size="18">mdi-shield-lock</v-icon>
        </v-tab>
        <v-tab class="user-info-tab">
            <span class="user-info-tab-text">로그인이력</span>
            <v-icon class="ml-1" size="18">mdi-history</v-icon>
        </v-tab>
        <v-tab class="user-info-tab">
            <span class="user-info-tab-text">유저 데이터정보</span>
            <v-icon class="ml-1" size="18">mdi-database</v-icon>
        </v-tab>
        <v-tab class="user-info-tab">
            <span class="user-info-tab-text">행성 버프</span>
            <v-icon class="ml-1" size="18">mdi-earth</v-icon>
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="userInfoTab">
        <v-tab-item>
    <v-list>   
        <v-list-item class="align-center">
            <!-- 닉네임 -->
            <div class="info-label-wide">
            <v-card-title class="font-weight-bold">닉네임</v-card-title>
            </div>
            <div class="info-label-wide d-flex align-center">
            <v-text-field
                v-model="selected_user_info.NICK"
                label="닉네임"
                dense
                outlined
                hide-details
                style="flex: 1;"
            ></v-text-field>
            <v-btn 
                color="primary" 
                @click="Change_UserNickName()" 
                small 
                style="margin-left: 8px; margin-right: 4px;"
            >
                저장
            </v-btn>
            </div>
            <v-divider vertical />
            <!-- 계정 생성일 -->
            <div class="info-label">
            <v-card-title class="font-weight-bold">계정 생성일</v-card-title>
            </div>
            <div class="info-label">
            <span>{{ selected_user_info.CREATE_DT }}</span>
            </div>
        </v-list-item>
        <v-divider />
        <v-list-item class="align-center">
            <!-- 핸드폰 인증 -->
            <div class="info-label-wide">
            <v-card-title class="font-weight-bold">핸드폰 인증</v-card-title>
            </div>
            <div class="info-label-wide d-flex align-center">
            <v-text-field
                v-model="selected_user_info.PHONE"
                label="핸드폰 번호"
                dense
                outlined
                hide-details
                style="flex: 1;"
            ></v-text-field>
            <v-btn 
                color="primary" 
                @click="Change_PhoneNumber()" 
                small 
                style="margin-left: 8px; margin-right: 20px;"
            >
                저장
            </v-btn>
            <v-btn
                color="red darken-1"
                outlined
                small
                :disabled="!selected_user_info.PHONE"
                @click="Reset_PhoneNumber()"
                style="margin-right: 20px;"
            >
                초기화
            </v-btn>
            </div>
            <v-divider vertical />
            <!-- 추천인 정보 -->
            <div class="info-label">
            <v-card-title class="font-weight-bold">추천인 정보</v-card-title>
            </div>
            <div class="info-label">
            <span>{{ selected_user_info.REFEREE_ID }}</span>
            </div>
        </v-list-item>
        <v-divider />
        <v-list-item class="align-center">
            <div class="info-label">
            <v-card-title class="font-weight-bold">채굴기</v-card-title>
            </div>
            <div class="info-label">
            <span>{{ selected_user_info.CUR_BP }}</span>
            </div>
            <v-divider vertical />
            <div class="info-label">
            <v-card-title class="font-weight-bold">오늘 획득 채굴기</v-card-title>
            </div>
            <div class="info-label">
            <span>{{ selected_user_info.DAILY_BP }}</span>
            </div>
            <v-divider vertical />
            <div style="flex:1; display:flex; justify-content:center; align-items:center;">
            <v-btn color="primary" @click="Show_User_CPU_Log">
                전체 리스트 보기
            </v-btn>
            </div>
        </v-list-item>
        <v-divider /> 
                <v-list-item class="align-center">
            <div class="info-label">
            <v-card-title class="font-weight-bold">보유코인</v-card-title>
            </div>
            <div class="info-label">
            <span>{{ selected_user_data.COIN }}</span>
            </div>
            <v-divider vertical />
            <div class="info-label">
            <v-card-title class="font-weight-bold">누적 획득 코인</v-card-title>
            </div>
            <div class="info-label">
            <span>{{ selected_user_data.TOTAL_EARN_COIN }}</span>
            </div>
            <v-divider vertical />
            <div style="flex:1; display:flex; justify-content:center; align-items:center;">
            <v-btn color="primary" @click="Show_User_Cash_Log">
                코인로그 리스트 보기
            </v-btn>
            </div>
        </v-list-item>
        <v-divider />
        <v-list-item class="align-center">
            <div class="info-label">
            <v-card-title class="font-weight-bold">구글/애플 리뷰이벤트</v-card-title>
            </div>
            <div class="info-label d-flex align-center">
            <span class="mr-2">{{ (selected_user_data.REVIEW_STATE || 'N') === 'Y' ? '검수완료' : (selected_user_data.REVIEW_STATE || 'N') }}</span>
            <v-btn
                v-if="(selected_user_data.REVIEW_STATE || 'N') === 'N'"
                color="success"
                small
                :loading="loadingReviewState"
                @click="OnClick_ReviewStateReward"
            >
                검수완료
            </v-btn>
            </div>
            <v-divider vertical />
            <div class="info-label">
            <v-card-title class="font-weight-bold">위젯이벤트</v-card-title>
            </div>
            <div class="info-label d-flex align-center">
            <span class="mr-2">{{ (selected_user_data.WIDGET_REVIEW_STATE || 'N') === 'Y' ? '검수완료' : (selected_user_data.WIDGET_REVIEW_STATE || 'N') }}</span>
            <v-btn
                v-if="(selected_user_data.WIDGET_REVIEW_STATE || 'N') === 'N'"
                color="success"
                small
                :loading="loadingWidgetReviewState"
                @click="OnClick_WidgetReviewStateReward"
            >
                검수완료
            </v-btn>
            </div>
        </v-list-item>      

        <v-divider />
        <v-list-item class="align-center">
            <div class="info-label-wide">
            <v-card-title class="font-weight-bold">추천인 수익 배분율</v-card-title>
            </div>
            <div class="info-label-wide d-flex align-center">
            <v-text-field
                v-model.number="friendSharePer"
                label="0.01 ~ 0.5"
                type="number"
                step="0.01"
                min="0.01"
                max="0.5"
                dense
                outlined
                hide-details
                style="flex: 1;"
            ></v-text-field>
            <v-btn
                color="primary"
                @click="Save_FriendSharePer()"
                small
                :loading="loadingFriendSharePer"
                style="margin-left: 8px; margin-right: 20px;"
            >
                저장
            </v-btn>
            </div>
        </v-list-item>

        <v-divider
        v-if='is_van'
        />

    </v-list>
        </v-tab-item>

        <v-tab-item>
    <v-list>
        <v-list-item v-if='is_van'>
        <span class="info-label"><v-card-title class="font-weight-bold">정지사유</v-card-title></span>        
        {{van_message}}
        </v-list-item>
        <v-divider/> 
     
        
        <v-divider/> 
        <v-list-item>
        <span class="info-label"><v-card-title class="font-weight-bold">이용정지 </v-card-title></span>       
        </v-list-item>
        <v-list-item>
        <span class="info-label-sm"><v-card-title class="font-weight-bold grey--text">EXP </v-card-title></span>        
        <v-text-field            
            label="고객에게 보여지는 이용정지의 이유(필수입력)"
            v-model="exp"
            value=""
            :disabled="is_van == true"    
        ></v-text-field>   
        </v-list-item>
        <v-list-item>
        <span class="info-label-sm"><v-card-title class="font-weight-bold grey--text">EXP_INFO </v-card-title></span>        
        <v-text-field            
            label="이용정지 관련 비고"
            v-model="expInfo"
            value=""
            :disabled="is_van == true"     
        ></v-text-field>         
        </v-list-item>
        <v-list-item>     
        <v-card-actions>
        <v-btn
            class="ml-2" 
            color='lime accent-3'  
            @click="OnClick_BanUser()" 
            right
            :disabled="is_van == false && exp != ''?false:true "
        >
            이용정지
        </v-btn>
        <v-btn 
            class= "ml-6" 
            color='lime accent-3' 
            @click="OnClick_UnbanUser()"
            :disabled="is_van == false"
        >
            이용정지 해제
        </v-btn>
        </v-card-actions>
        </v-list-item>
    </v-list>
        </v-tab-item>

        <v-tab-item>
    <v-list>
        <v-data-table         
        :headers="headers_login" 
        :items="login_history"
        hide-default-footer       
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.DEVICE}}</td>
            <td>{{row.item.DEVICE_ID}}</td>
            <td>{{row.item.LOG_INFO}}</td>
            <td>{{row.item.LOG_DT}}</td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
        </v-tab-item>

        <v-tab-item>
    <v-toolbar
        color="#37474F"
        dark
        dense
    >    
    <v-toolbar-title>유저 데이터 정보</v-toolbar-title>   
    <v-spacer></v-spacer> 
    <span></span>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= "blue-grey darken-1"
            >mdi-help</v-icon>
        </v-btn>
    </template>
    <span>유저 데이터정보는 어드민에서 저장하면 데이터 버전이 오르게 됨으로 디바이스는 재로그인 되도록 되도록 가이드합니다.</span>
    </v-tooltip>
    
    </v-toolbar>
    <v-list>
        <v-list-item>
        <span class="info-label-sm"><v-card-title class="font-weight-bold">데이터 버전</v-card-title></span>        
        <span style="color:red">
            {{this.selected_user_data.VERSION}}
        </span>
        <div class="px-6"></div>
        <v-divider vertical/>
        <div class="px-6"></div>
        <span class="info-label"><v-card-title class="font-weight-bold">마지막 저장 시점</v-card-title></span>        
        <span style="color:red">
            {{this.selected_user_data.VERSION}}
        </span>
        </v-list-item>       
        <v-divider class="my-3"/>
        <v-list-item v-if='!isLive'>
            <span class="info-label-sm"><v-card-title class="font-weight-bold">데이터 덮기</v-card-title></span>                    
            <v-textarea
            filled
            v-model="user_data_override"
            name="input-7-4"
            label="통으로 덮으려는 유저 데이터를 입력하세요."
            value=""
            ></v-textarea>                   
        <div class="px-1"/>
        <span class="info-label-xs"><v-btn color='lime accent-3' @click="OnClick_Data_Overriding()">데이터 덮기</v-btn></span>                
        </v-list-item>
        <v-divider/>
        <v-list-item>
            <v-card-title class="font-weight-bold">유저 데이터</v-card-title>            <v-divider vertical/><v-spacer/>

            <span ><v-btn color='green accent-4' @click="OnClick_CopyClipboard()">유저 데이터 클립보드에 복사하기</v-btn></span><v-spacer/>
            <!-- <span  v-if='!isLive'>><v-btn color='lime accent-3' @click="OnClick_Data_Saving()">저장하기</v-btn></span> -->
            <span><v-btn color='lime accent-3' @click="OnClick_Data_Saving()">저장하기</v-btn></span>
        </v-list-item>
 
    <vue-json-editor 
    with     
    v-model="selected_json" 
    :show-btns="false" 
    :expandedOnStart="true" 
    @json-change="onJsonChange">
    </vue-json-editor> 



    <v-list-item>

    </v-list-item>
    </v-list>
        </v-tab-item>

        <!-- 행성 버프 내역 -->
        <v-tab-item>
          <v-card flat class="pa-4">
            <div class="d-flex align-center mb-3">
              <v-icon left color="deep-purple">mdi-earth</v-icon>
              <span class="text-subtitle-1 font-weight-bold">행성 버프 내역</span>
              <v-chip x-small class="ml-2" color="deep-purple lighten-4">{{ planetList.length }}건</v-chip>
              <v-spacer></v-spacer>
              <v-btn small text @click="loadPlanetList"><v-icon small>mdi-refresh</v-icon></v-btn>
            </div>
            <v-data-table
              :headers="planetHeaders"
              :items="planetList"
              :loading="!planetLoaded"
              dense
              :items-per-page="20"
              no-data-text="획득한 행성 버프 내역이 없습니다."
              class="elevation-1"
            >
              <template v-slot:[`item.PLANET_TYPE`]="{ item }">
                <v-chip x-small :color="planetColor(item.PLANET_TYPE) + ' lighten-4'" :text-color="planetColor(item.PLANET_TYPE) + ' darken-3'">
                  {{ planetName(item.PLANET_TYPE) }}
                </v-chip>
              </template>
              <template v-slot:[`item.BONUS_PERCENT`]="{ item }">
                채굴강화 +{{ item.BONUS_PERCENT }}
              </template>
              <template v-slot:[`item.IS_ACTIVE`]="{ item }">
                <v-chip x-small :color="item.IS_ACTIVE === 'Y' ? 'green lighten-4' : 'grey lighten-2'">
                  {{ item.IS_ACTIVE === 'Y' ? '활성' : '만료' }}
                </v-chip>
              </template>
            </v-data-table>
            <div class="text-caption grey--text mt-2">
              행성 등급(PLANET_TYPE)은 게임 config(PLANET.DRAW_TABLE) 기준 — 솔라(SSR)/쥬피터(SR)/새턴(R)/넵튠(N+)/우라노스(N). 활성 행성의 채굴강화(BONUS_PERCENT)는 합연산으로 적용됨.
            </div>
          </v-card>
        </v-tab-item>
    </v-tabs-items>
    </v-card>
    
    <div class="py-12"></div>
    <div class="py-12"></div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          이용정지 처리를 진행합니다.
        </v-card-title>
        <v-card-text>EXP : {{exp}}</v-card-text>
        <v-card-text>EXP_INFO : {{expInfo}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="Submit_BanUser"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog2"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          이용정지 취소를 진행합니다.
        </v-card-title>
        <v-card-text>이용정지가 취소되어 유저는 다시 개임을 이용하는것이 가능해집니다.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog2 = false"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="Submit_UnbanUser"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
   <v-dialog
  v-model="dialog_referee_list"
  max-width="1200"
>
  <v-card>
    <v-card-title class="text-h5">
      추천인 리스트 ( {{ dialog_referee_list_items.length }} 명)
    </v-card-title>

    <div style="max-height: 1200px; overflow-y: auto;">
      <v-data-table         
        :headers="headers_referees" 
        :items="dialog_referee_list_items"
        :items-per-page="20"      
        class="elevation-1"
      >        
        <template v-slot:item="row">            
          <tr>
            <td>{{ row.item.USER_ID }}</td>
            <td><b>{{ row.item.NICK }}</b></td>
            <td>{{ row.item.PHONE }}</td>
            <td :style="{ color: row.item.CUR_BP == 0 ? 'red' : '' }">{{ row.item.CUR_BP }}</td>
            <td>{{ row.item.CREATE_DT }}</td>          
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="Close_Dialogs"
      >
        확인
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<!-- 채굴기 리스트  -->
  <v-dialog
  v-model="dialog_cpu_list"
  max-width="1200"
>
  <v-card>
    <v-card-title class="text-h5">
      적용중인 채굴기 리스트 ( {{ dialog_cpu_list_items.length }} 개)
    </v-card-title>

    <div style="max-height: 1200px; overflow-y: auto;">
      <v-data-table         
        :headers="headers_cpu" 
        :items="dialog_cpu_list_items"
        :items-per-page="20"      
        class="elevation-1"
      >        
        <template v-slot:item="row">            
          <tr>
            <td><b>{{ row.item.SOURCE_TYPE }}</b></td>
            <td><b>{{ row.item.SOURCE_EXP }}</b></td>
            <td><b>{{ row.item.BONUS_POINT }}</b></td>
            <td>{{ row.item.START_TIME }}</td>
            <td>
                <v-btn class="mx-2" fab dark small color="red darken-1" @click="OnClick_RefundCPU(row.item)">
                    <v-icon dark>mdi-backup-restore</v-icon>
                </v-btn>
            </td>
            
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="Close_Dialogs"
      >
        확인
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<!-- 캐시로그 리스트  -->
  <v-dialog
  v-model="dialog_cashlog_list"
  max-width="1200"
>
  <v-card>
    <v-card-title class="text-h5">
      캐시 획득 사용로그 ( {{ dialog_referee_list_items.length }} 명)
    </v-card-title>

    <div style="max-height: 1200px; overflow-y: auto;">
      <v-data-table         
        :headers="headers_cash" 
        :items="dialog_cashlog_list_items"
        :items-per-page="20"      
        class="elevation-1"
      >        
        <template v-slot:item="row">            
          <tr>
            <td><b>{{ row.item.EXP }}</b></td>
            <td :style="{ color: row.item.CHANGE_TYPE === 'A' ? 'blue' : 'red' }">              
                <b>{{ row.item.CHANGE_TYPE === 'A'?'획득':'사용'}}</b>
            </td>
            <td :style="{ color: row.item.CHANGE_TYPE === 'A' ? 'blue' : 'red' }">
                <b>{{ row.item.COIN_CHANGE }}</b>   
            </td>
            <td>{{ row.item.COIN_FINAL }}</td>
            <td>{{ row.item.DT_CREATE }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="Close_Dialogs"
      >
        확인
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>



<!-- 채굴기 회수하기   -->
  <v-dialog    
  v-model="dialog_refund_base"
  persistent
  max-width="800"
>
  <v-card>
    <v-card-title class="text-h5">
      지급된 채굴기를 환수합니다. 
    </v-card-title>

    <div style="">
        <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">소스타입</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">{{ selected_refund_cpu_item.SOURCE_TYPE }}</v-col>
        </v-row>
        <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">설명</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">{{ selected_refund_cpu_item.SOURCE_EXP }}</v-col>
        </v-row>
        <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">채굴기 포인트 %</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">{{ selected_refund_cpu_item.BONUS_POINT }}</v-col>
        </v-row>
        <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">생성일</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">{{ selected_refund_cpu_item.START_TIME }}</v-col>
        </v-row>
         <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">지급후 유지시간(H)</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">
                {{ Math.floor(getElapsedHours(selected_refund_cpu_item.START_TIME)) }} 시간  ({{ Math.floor(getElapsedHours(selected_refund_cpu_item.START_TIME)/24) }} 일)
            </v-col>
        </v-row>
         <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">시간으로 계산된 코인수량</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">{{ getElapsedSeconds(selected_refund_cpu_item.START_TIME) *  0.0000000003003 * (selected_refund_cpu_item.BONUS_POINT / 100) }} ({{getElapsedSeconds(selected_refund_cpu_item.START_TIME)}}초)</v-col>
        </v-row>
        <v-divider />
         <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">현재 유저 코인수량</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">{{ selected_user_data.COIN }}</v-col>
        </v-row>
        <v-divider />
        <v-row class="py-2">
            <v-col cols="4" class="text-right font-weight-bold">회수할 코인 수량</v-col>
            <v-divider vertical/>
            <v-col cols="8" class="text-left">
                <v-text-field
                    label="회수해야하는 코인 수량"
                    v-model="dialog_refund_coin_value"
                    :class="{ 'text-red': Number(dialog_refund_coin_value) > Number(selected_user_data.COIN) }"
                    />
            </v-col>
        </v-row>
        <v-divider />
        <v-row class="py-4">
            <v-col cols="12" class="text-center">
                <v-btn color="red darken-2" dark @click="UserCPU_Refund">
                    <v-icon left>mdi-backup-restore</v-icon>
                    채굴기 환수하기
                </v-btn>
            </v-col>
        </v-row>
        <v-divider />
        
    </div>
    <!-- <td><b>{{ row.item.SOURCE_TYPE }}</b></td>
            <td><b>{{ row.item.SOURCE_EXP }}</b></td>
            <td><b>{{ row.item.BONUS_POINT }}</b></td>
            <td>{{ row.item.START_TIME }}</td> -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="Close_Dialog_Refund"
      >
        닫기
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  
    </div>   
</template>

<script>
import XLSX from 'xlsx';
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'


//import JsonViewer from 'vue-json-viewer'
//import VueJsonPretty from 'vue-json-pretty'
//import vue from 'vue'
// import JsonEditor from 'vue-json-edit'
import vueJsonEditor from 'vue-json-editor'
export default {
    name: 'UserList',

    data: () => ({
        userInfoTab: 0,
        goodsDialog: false,
        goodsHeaders: [         
           { text: '태그', value: 'TAG'},
            { text: '패키지', value: 'PACKAGE' },
            { text: '재화타입', value: 'CASH_TYPE' },
            { text: '변화량', value: 'CHANGE_AMOUNT'},
            { text: '남은량', value: 'AMOUNT' },
            { text: 'EXP', value: 'EXP' },
            { text: '생성일', value: 'LOG_DT' },
            { text: '채녈', value: 'CHANNEL' }
        ],
        menu: false,
        menu2:false,
        date:moment().subtract(3,'M').format('yyyy-MM-DD'),
        date2:moment().format('yyyy-MM-DD'),
        goodsLogDatas:[],
        waitingLogDatas:false,

        // 채팅 로그
        chatDialog: false,
        chatHeaders: [         
           { text: '패키지', value: 'PACKAGE'},
            { text: '채널', value: 'CHANNEL' },
            { text: '메시지', value: 'MESSAGE' },
            { text: '타입', value: 'MESSAGE_TYPE'},
            { text: '터겟ID', value: 'TARGET_ID' },
            { text: '유저ID', value: 'USER_ID' },
            { text: '닉네임', value: 'USER_NICK' },
            { text: '랭킹', value: 'RANKING' },
            { text: '길드', value: 'GUILD' },
            { text: '뱃지', value: 'BADGE' },
            { text: 'BAN', value: 'BAN' },
            { text: '생성일', value: 'CREATED_DT' }
        ],
        menu3: false,
        menu4:false,
        date3:moment().subtract(3,'M').format('yyyy-MM-DD'),
        date4:moment().format('yyyy-MM-DD'),
        chatLogDatas:[],
        waitingChatLogDatas:false,

        loadingReviewState: false,
        loadingWidgetReviewState: false,
        friendSharePer: 0.5,
        loadingFriendSharePer: false,
        dialog:false,
        dialog2:false,
        exp:'',
        expInfo:'',
        is_change_data:false,
        targetUser:'USER_ID',
        is_van:false,
        van_message : '',
        isMailAll:false,
        loadingData:false,    
        access_token:'',
        selected_user_info:{},
        selected_user_data:{},
        referee_user_list:[],


        date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_end:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        user_data_override : '', 
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        headers_login: [            
            { text: '디바이스', value: 'DEVICE' },
            { text: '디바이스 ID', value: 'DEVICE ID' },
            { text: 'LOGIN INFO', value: 'LOGIN INFO' },
            { text: '날짜', value: 'LOG_DT' },
        ],
        headers_referees: [
            { text :'유저 아이디', value: 'USER_ID' },
            { text: '닉네임', value: 'NICK'},
            { text: '전화번호', value: 'PHONE'},
            { text: '적용중 채굴기', value: 'CUR_BP'},
            { text: '생성일', value: 'CREAT_DT'},
        ],
        headers_cpu: [
            { text : '소스타입', value: 'USER_ID' },
            { text: '설명', value: 'NICK'},
            { text: '채굴기 포인트', value: 'CUR_BP'},
            { text: '생성일', value: 'PHONE'},
            { text: '회수', value: 'Refund'},
        ],
        headers_cash: [
            { text : '설명', value: 'USER_ID' },
            { text: '상태', value: 'NICK'},
            { text: '변화수량', value: 'CUR_BP'},
            { text: '최종수량', value: 'PHONE'},
            { text: '날짜', value: 'DT_CREATE'},
        ],


        login_history:[
            
        ],
        selected_json: {
            titie:'this is title Date',
            msg: 'demo of jsoneditor',
            item_lev_1:'1',
            item_lev_2:'2',
            item_lev_3:'3',
            item_lev_4:'4',
            item_info:[{'key1':'value1',},{'key1':'value2',},{'key1':'value3',},{'key1':'value4',} ]

        },

        selected_channel_data:1,

        sum_purchase_cost: 0,

        dialog_referee_list:false,
        dialog_referee_list_items:[],
        dialog_referee_list_items_loaded:false,
        // 행성 버프 내역
        planetList: [],
        planetLoaded: false,
        planetHeaders: [
          { text: '행성', value: 'PLANET_TYPE', width: 110 },
          { text: '채굴강화', value: 'BONUS_PERCENT', width: 130 },
          { text: '상태', value: 'IS_ACTIVE', width: 90 },
          { text: '획득시각', value: 'DT_CREATE' },
          { text: '만료시각', value: 'DT_EXPIRE' },
        ],
        planetMeta: {
          SSR: { name: '솔라 (SSR)',   color: 'deep-purple' },
          SR:  { name: '쥬피터 (SR)',  color: 'indigo' },
          R:   { name: '새턴 (R)',     color: 'blue' },
          NH:  { name: '넵튠 (N+)',    color: 'teal' },
          N:   { name: '우라노스 (N)', color: 'blue-grey' },
        },

        dialog_cpu_list:false,
        dialog_cpu_list_items:[],
        dialog_cpu_list_items_loaded:false,

        dialog_cashlog_list:false, 
        dialog_cashlog_list_items:[], 
        dialog_cashlog_list_items_loaded:false,


        selected_refund_cpu_item:{},
        dialog_refund_base:false,
        dialog_refund_coin_value:0,


    }),

    created()
    {
        this.date_end = moment().add(1,'M').format('yyyy-MM-DD');
        let queryData = this.$route.query;
        this.targetUser = queryData.USER_ID;
        console.log(queryData);
        this.LoadUserData();
    },

    methods:{
        ...mapActions([
            'BAN_USER',
            'UNBAN_USER',
            'GET_USER_INFO',
            'CPU_SET_REVIEW_STATE_REWARD',
            'CPU_SET_WIDGET_REVIEW_STATE_REWARD',
            'SET_USER_INFO_DATA',
            // 재화 로그 데이터를 요청하는 로직
            'GET_GOODS_LOG_DATA',
            // 채팅 로그 데이터를 요청하는 로직
            'GET_CHAT_LOG_DATA',
            'USER_BILLING_COST_SUM',

            'CHANGE_USER_NICK_NAME',
            'SET_USER_PHONE_NUMBER',
            'RESET_USER_PHONE',
            'GET_USER_REFEREE_LIST',
            'GET_USER_CPU_LIST',
            'GET_USER_PLANET_LIST',
            'GET_USER_CASHLOG_LIST',
            'REFUND_USER_CPU',
            'SET_FRIEND_SHARE_PER'
        ]),
        downGoodsLog()
        {
            console.log('다운로드 버튼 클릭됨')

            var ws = XLSX.utils.json_to_sheet(this.goodsLogDatas);
            let wb = XLSX.utils.book_new();

            // 시트의 이름
            XLSX.utils.book_append_sheet(wb, ws,`${this.targetUser} 재화사용로그`);
            // 파일의 이름
            XLSX.writeFile(wb, `[ ${this.$store.state.selected_game_package} ] ${this.targetUser} 재화사용로그 ( ${(new Date).toLocaleString()} ).xlsx`);
        },
        openGoodsDiolog()
        {
            this.goodsDialog = false
            this.goodsLogDatas = []
        },
        closeGoodsDiolog()
        {
            this.goodsDialog = false
            this.goodsLogDatas = []
        },
        async getGoodsLogData()
        {
            console.log('굿즈 데이터 가져오기 실행됨')
            this.goodsLogDatas = []
            this.waitingLogDatas = true
            const packageName = this.$store.state.selected_game_package
            const server_index = this.$store.state.selected_game_server;

            const user_id = this.targetUser
            const start_date = this.date
            const end_date = this.date2
            this.goodsLogDatas = (await this.GET_GOODS_LOG_DATA({packageName,user_id,start_date, end_date ,server_index })).result
            this.waitingLogDatas = false
            console.log(this.goodsLogDatas)
        },

        downChatLog()
        {
            console.log('다운로드 버튼 클릭됨')

            var ws = XLSX.utils.json_to_sheet(this.chatLogDatas);
            let wb = XLSX.utils.book_new();

            // 시트의 이름
            XLSX.utils.book_append_sheet(wb, ws,`${this.targetUser} 채팅 로그`);
            // 파일의 이름
            XLSX.writeFile(wb, `[ ${this.$store.state.selected_game_package} ] ${this.targetUser} 채팅로그 ( ${(new Date).toLocaleString()} ).xlsx`);
        },
        openChatDiolog()
        {
            this.chatDialog = false
            this.chatLogDatas = []
        },
        closeChatDiolog()
        {
            this.chatDialog = false
            this.chatLogDatas = []
        },
        async getChatLogData()
        {
            console.log('굿즈 데이터 가져오기 실행됨')
            this.chatLogDatas = []
            this.waitingChatLogDatas = true
            const packageName = this.$store.state.selected_game_package
            const server_index = this.$store.state.selected_game_server;
            const user_id = this.targetUser
            const start_date = this.date3
            const end_date = this.date4
            this.chatLogDatas = (await this.GET_CHAT_LOG_DATA({packageName,user_id,start_date, end_date ,server_index})).result
            this.waitingChatLogDatas = false
            console.log(this.chatLogDatas)
        },

        LoadUserData()
        {

            let user_id = this.targetUser;
            let target_user = user_id;
            //console.log(target_user)
            // this.USER_BILLING_COST_SUM({packageName , user_id}).then((body_data)=>{
            //     if(body_data['SUM_COST'] != undefined)
            //     {
            //         this.sum_purchase_cost = body_data['SUM_COST']
            //     }
            // });

            this.GET_USER_INFO({target_user}).then((body_data)=>{
                console.log('body_data',JSON.stringify(body_data))
                if(body_data.bad_user != undefined)
                {//정보가 있고
                    console.log('정보있음 분기')
                    if(body_data.bad_user.CANCEL_YN == 'N')
                    {
                        console.log('캔슬 안됨 분기')
                        this.is_van = true;
                        console.log('is_van 에 true 대입')
                        this.van_message = body_data.bad_user.EXP;
                    } else {
                        console.log('캔슬됨 분기')
                        this.is_van = false
                        console.log('is_van 에 false 대입')
                    } 
                } else {
                    console.log('정보 없음 분기')
                    this.is_van = false
                    console.log('is_van 에 false 대입')
                }
                //user_nick
                this.login_history = body_data.auth_logs;
                this.selected_user_info  = body_data.user_info;
                this.friendSharePer = body_data.user_info.FRIEND_SHARE_PER ?? 0.5;
                this.selected_user_data =  body_data.user_data;
                this.access_token = body_data.access_token;
                this.channel_info_Container = [];
                
                this.selected_json = body_data.user_data.DATA;//유저 데이터 설정 

                this.is_change_data = false;
                this.selected_json = this.selected_user_data.DATA;
                this.user_data_override = '';
            });
            this.loadPlanetList();
        },
        planetName(type) {
            const m = this.planetMeta[type];
            return m ? m.name : (type || '-');
        },
        planetColor(type) {
            const m = this.planetMeta[type];
            return m ? m.color : 'grey';
        },
        async loadPlanetList() {
            if (!this.targetUser) { this.planetList = []; this.planetLoaded = true; return; }
            this.planetLoaded = false;
            try {
                const body = await this.GET_USER_PLANET_LIST({ user_id: this.targetUser });
                this.planetList = (body && body.result) || [];
            } catch (e) {
                console.error('[planet] loadPlanetList', e);
                this.planetList = [];
            } finally {
                this.planetLoaded = true;
            }
        },
        Refresh_UserData()
        {//가져온 유저

        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            this.$router.push('/game_mail?USER_ID='+_item.USER_ID);
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        onJsonChange (value) {
            //console.log('value:', value)
            this.is_change_data = true;
        },
        OnClick_DownChattingLog()
        {
            alert("채팅로그 다운받기 기능이 실행되었습니다");
        },
        OnClick_DownCashLog()
        {
            alert("캐시로그 다운받기는 준비중입니다.");
        },
        OnClick_BanUser()
        {
            this.dialog = true
        },
        OnClick_UnbanUser()
        {
            this.dialog2 = true
        },
        Submit_BanUser()
        {   
            this.BanUser()
            this.dialog = false
        },
        Submit_UnbanUser()
        {   
            this.UnbanUser()
            this.dialog2 = false
        },
        async OnClick_ReviewStateReward() {
            if (!this.targetUser) return;
            this.loadingReviewState = true;
            try {
                const res = await this.CPU_SET_REVIEW_STATE_REWARD({ user_id: this.targetUser });
                const updated = res?.response_data?.updated ?? res?.res_data?.updated ?? true;
                if (updated) {
                    this.$set(this.selected_user_data, 'REVIEW_STATE', 'Y');
                }
                const msg = res?.response_data?.message ?? res?.res_data?.message ?? '처리되었습니다.';
                alert(msg);
            } finally {
                this.loadingReviewState = false;
            }
        },
        async OnClick_WidgetReviewStateReward() {
            if (!this.targetUser) return;
            this.loadingWidgetReviewState = true;
            try {
                const res = await this.CPU_SET_WIDGET_REVIEW_STATE_REWARD({ user_id: this.targetUser });
                const updated = res?.response_data?.updated ?? res?.res_data?.updated ?? true;
                if (updated) {
                    this.$set(this.selected_user_data, 'WIDGET_REVIEW_STATE', 'Y');
                }
                const msg = res?.response_data?.message ?? res?.res_data?.message ?? '처리되었습니다.';
                alert(msg);
            } finally {
                this.loadingWidgetReviewState = false;
            }
        },
        async BanUser()
        {   
            const packageName = this.$store.state.selected_game_package;
            const server_index = this.$store.state.selected_game_server;
            
            const exp = this.exp
            const exp_info = this.expInfo
            const target_user = this.targetUser
            const result = await this.BAN_USER({ packageName, target_user, exp, exp_info, server_index})
            this.clear()
            this.LoadUserData()
            alert('이용정지 처리되었습니다. 반영 될 떄까지 잠시 기다려주세요')

        },
        async UnbanUser()
        {
            const target_user = this.targetUser;
            const result = await this.UNBAN_USER({ target_user });
            this.LoadUserData()
            alert('이용정지 해제되었습니다. 반영 될 떄까지 잠시 기다려주세요')

        },
        clear()
        {
            this.exp = '';
            this.expInfo = '';
        },
        OnClick_Data_Saving()//데이터를 저장한다 
        {
            if(!this.is_change_data)
            {
                alert("변경된 데이터가 없습니다.");                
            }
            let user_id = this.targetUser;            
            let data = this.selected_json;
            console.log("SET_USER_INFO_DATA : " + user_id);
            this.SET_USER_INFO_DATA({ user_id ,  data }).then((body_data)=>{
                alert('저장완료');
                this.LoadUserData();
            });

        },
        OnClick_Data_Overriding()
        {
            if(this.user_data_override == '')
            {
                alert('입력하려는 데이터가 없습니다.');
                return;
            }
            let user_id = this.targetUser;            
            let data = JSON.parse(this.user_data_override);
            this.SET_USER_INFO_DATA({user_id , data }).then((body_data)=>{
                alert('저장완료');//{"KEY":"VALUE"}
                this.LoadUserData();
            });
        },
        OnClick_CopyClipboard()
        {
            console.log(JSON.stringify(this.selected_json))
            this.$copyText(JSON.stringify(this.selected_json));
            alert("클립보드에 정보가 복사되었습니다.");
        },
        Change_UserNickName(){
            
             this.CHANGE_USER_NICK_NAME({user_id: this.targetUser, nick:this.selected_user_info.NICK}).then((body_data)=>{
                    alert('변경완료');
                });
        },
        Reset_PhoneNumber(){
            const phone = this.selected_user_info.PHONE;
            if (!phone) return;
            if (!confirm(`[${this.targetUser}] 유저의 전화번호(${phone})를 초기화 하겠습니까?\n초기화 이력(어드민/시각/번호)이 기록됩니다.`)) return;
            this.RESET_USER_PHONE({ user_id: this.targetUser }).then((body_data)=>{
                if (body_data && body_data.state === 'already_empty') {
                    alert('이미 전화번호가 비어있는 유저입니다.');
                } else {
                    alert('전화번호가 초기화 되었습니다.');
                }
                this.selected_user_info.PHONE = '';
            }).catch((err)=>{
                console.error(err);
                alert('전화번호 초기화 실패: ' + err);
            });
        },
        Change_PhoneNumber(){
            if(this.selected_user_info.PHONE == '')
            {
                alert('전화번호가 입력되지 않았습니다.');
                return;
            }
            //this.selected_user_info.PHONE = this.formatPhoneNumber(this.selected_user_info.PHONE);
            this.SET_USER_PHONE_NUMBER({user_id: this.targetUser, phone:this.selected_user_info.PHONE}).then((body_data)=>{
                console.log('전화번호 변경 결과: ', body_data);
                if(body_data.state == 'success')
                    alert('변경완료');
                else if(body_data.state == 'already_exist'){
                    alert('변경실패 : 이미 이용중인 번호 입니다.');
                    this.LoadUserData();
                }
                else
                    alert('알수없는 오류가 발생했습니다.');
                });
        },
        async Save_FriendSharePer() {
            const val = Number(this.friendSharePer);
            if (isNaN(val) || val < 0.01 || val > 0.5) {
                alert('FRIEND_SHARE_PER는 0.01 ~ 0.5 사이의 값이어야 합니다.');
                return;
            }
            this.loadingFriendSharePer = true;
            try {
                const res = await this.SET_FRIEND_SHARE_PER({ user_id: this.targetUser, friend_share_per: val });
                if (res && res.state !== 'fail') {
                    alert('배분율 변경 완료');
                } else {
                    alert('변경 실패: ' + (res?.err_info?.err_message || '알 수 없는 오류'));
                }
            } catch (e) {
                alert('변경 실패: ' + (e.message || '서버 오류'));
            }
            this.loadingFriendSharePer = false;
        },
        Show_UserReferees(){
            if(!this.dialog_referee_list_items_loaded){
                this.GET_USER_REFEREE_LIST({user_id: this.targetUser}).then((body_data)=>{
                    this.dialog_referee_list_items = body_data.result;
                    console.log('추천인들의 정보를 가져옵니다. ' + JSON.stringify(body_data));
                    
                    console.log('추천인들의 정보를 가져옵니다. ' + JSON.stringify(this.dialog_referee_list_items));
                    this.dialog_referee_list = true;                    
                    this.dialog_referee_list_items_loaded = true;
                });
            }else{
                this.dialog_referee_list = true;
            }
            //this.dialog_referee_list_items.length
            
        },
        Close_Dialogs(){
            this.dialog_referee_list = false;
            this.dialog_cpu_list = false;
            this.dialog_cashlog_list = false;
        },

        Show_User_CPU_Log(){
            //alert('유저의 채굴기 로그를 보여줍니다.');
            //dialog_cpu_list
            if(!this.dialog_cpu_list_items_loaded){
                this.GET_USER_CPU_LIST({user_id: this.targetUser}).then((body_data)=>{
                    this.dialog_cpu_list_items = body_data.result;
                    console.log('채굴기 정보를 가져옵니다. ' + JSON.stringify(body_data));
                    
                    console.log('추천인들의 정보를 가져옵니다. ' + JSON.stringify(this.dialog_cpu_list_items));
                    this.dialog_cpu_list = true;                    
                    this.dialog_cpu_list_items_loaded = true;                    
                });
            }else{
                this.dialog_cpu_list = true;
            }
        },
        Show_User_Cash_Log(){
            if(!this.dialog_cashlog_list_items_loaded){
                this.GET_USER_CASHLOG_LIST({user_id: this.targetUser}).then((body_data)=>{
                    this.dialog_cashlog_list_items = body_data.result;                    
                    this.dialog_cashlog_list = true;                    
                    this.dialog_cashlog_list_items_loaded = true;
                });
            }else{
                this.dialog_cashlog_list = true;
            }
        },
        OnClick_RefundCPU(cpu_item){
            this.selected_refund_cpu_item = cpu_item;
            this.dialog_refund_coin_value = this.getElapsedSeconds(this.selected_refund_cpu_item.START_TIME) *  0.0000000003003 * (this.selected_refund_cpu_item.BONUS_POINT / 100);
            this.dialog_refund_base = true;            
        },
        UserCPU_Refund(){
            let bonus_log_pid = this.selected_refund_cpu_item.PID;
            let refund_cash =  this.getElapsedSeconds(this.selected_refund_cpu_item.START_TIME) *  0.0000000003003 * (this.selected_refund_cpu_item.BONUS_POINT / 100);
            let user_id = this.targetUser;
            //user_id , bonus_log_pid , refund_cash
            
            this.REFUND_USER_CPU({user_id, bonus_log_pid , refund_cash}).then((body_data)=>{
                //console.log('body_data',JSON.stringify(body_data))
                this.LoadUserData();
                this.dialog_refund_base = false;
                this.dialog_cashlog_list = false;
                this.dialog_cpu_list = false;
                this.selected_refund_cpu_item = {}; 
                this.dialog_cpu_list_items_loaded = false;
                alert('채굴기 환수처리 되었습니다.');
                
            });
        },
        Close_Dialog_Refund(){
            this.dialog_refund_base = false;
        },
        getElapsedHours(startTime) {
            if (!startTime) return 0;
            const start = moment(startTime, "YYYY-MM-DD HH:mm:ss", true);
            if (!start.isValid()) return 0;
            const now = moment();
            const diff = now.diff(start, 'hours', true); // float
            return diff.toFixed(0); // 정수 문자열 반환
        },

        getElapsedSeconds(startTime) {
            if (!startTime) return 0;
            const start = moment(startTime, "YYYY-MM-DD HH:mm:ss", true);
            if (!start.isValid()) return 0;
            const now = moment();
            const diff = now.diff(start, 'seconds'); // 정수 초
            return diff;
        },
        formatPhoneNumber(phone) {
                if (!phone) return '';
                // Ensure phone is a string
                const phoneStr = String(phone);
                // Remove non-digit characters
                const digits = phoneStr.replace(/\D/g, '');
                // Format as 010-1234-5678 or similar
                if (digits.length === 11) {
                    return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
                } else if (digits.length === 10) {
                    return digits.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
                }
                return phoneStr;
            }                

    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },  
        MailType_TabColor()
        {
            if(this.is_van)
                return "red accent-4";
            else
                return "#37474F";
        },   
        Purchase_Sum_String()
        {
            return this.sum_purchase_cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    components:{
        vueJsonEditor
    },
    watch :{
        goodsDialog: function() {
            if (this.goodsDialog == true){
                this.getGoodsLogData()
            }
        },
        chatDialog: function() {
            if (this.chatDialog == true){
                this.getChatLogData()
            }
        },
        '$store.state.selected_game_server': function() {
            //this.LoadUserData();
            //this.loadingData = false;
            //this.$router.push('/user_info?USER_ID='+_item.USER_ID);
            this.$router.go(-1);
        }
    },

};
</script>
<style scoped>
.userinfo-toolbar {
  padding: 12px 16px;
}
.userinfo-toolbar__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.userinfo-toolbar__title {
  font-size: 18px;
  font-weight: 600;
}
.userinfo-toolbar__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
@media (max-width: 600px) {
  .userinfo-toolbar__row {
    flex-direction: column;
    align-items: flex-start;
  }
  .userinfo-toolbar__title {
    font-size: 15px;
  }
}
.info-label-wide { width: 300px; }
.info-label { width: 200px; }
.info-label-sm { width: 150px; }
.info-label-xs { width: 120px; }
@media (max-width: 600px) {
  .info-label-wide,
  .info-label,
  .info-label-sm,
  .info-label-xs { width: auto; min-width: 0; }
}
::v-deep .text-red input {
  color: red !important;
}

/* 유저정보 탭 버튼 스타일 */
.user-info-tabs {
  border-bottom: 2px solid #e0e0e0;
}
.user-info-tabs ::v-deep .v-tab {
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: none;
  letter-spacing: 0;
  min-height: 52px;
  padding: 0 20px;
}
.user-info-tabs ::v-deep .v-tab--active {
  color: rgb(25, 118, 210);
  background-color: rgba(25, 118, 210, 0.08);
}
.user-info-tabs ::v-deep .v-tabs-slider {
  height: 3px;
}
.user-info-tab-text {
  margin-right: 4px;
}

/* Mobile responsive adjustments */
@media (max-width: 600px) {
  .v-list-item {
    flex-wrap: wrap;
  }
  .v-list-item > div {
    width: 100% !important;
  }
  .v-list-item .v-card__title {
    padding: 8px 0;
  }
}
</style>
